module.exports = __webpack_public_path__ + "img/8.03026059.png";